/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * squad object
 * @export
 * @interface GetFleetsFleetIdWingsSquad
 */
export interface GetFleetsFleetIdWingsSquad {
    /**
     * id integer
     * @type {number}
     * @memberof GetFleetsFleetIdWingsSquad
     */
    id: number;
    /**
     * name string
     * @type {string}
     * @memberof GetFleetsFleetIdWingsSquad
     */
    name: string;
}

/**
 * Check if a given object implements the GetFleetsFleetIdWingsSquad interface.
 */
export function instanceOfGetFleetsFleetIdWingsSquad(value: object): value is GetFleetsFleetIdWingsSquad {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function GetFleetsFleetIdWingsSquadFromJSON(json: any): GetFleetsFleetIdWingsSquad {
    return GetFleetsFleetIdWingsSquadFromJSONTyped(json, false);
}

export function GetFleetsFleetIdWingsSquadFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFleetsFleetIdWingsSquad {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function GetFleetsFleetIdWingsSquadToJSON(json: any): GetFleetsFleetIdWingsSquad {
    return GetFleetsFleetIdWingsSquadToJSONTyped(json, false);
}

export function GetFleetsFleetIdWingsSquadToJSONTyped(value?: GetFleetsFleetIdWingsSquad | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

